import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://e.haazri.net/api';

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Landing Page API Service
const landingPageAPI = {
  // Public endpoints
  getAllContent: () => api.get('/landing_page_api.php'),
  getCarousel: () => api.get('/landing_page_api.php/carousel'),
  getFeatures: () => api.get('/landing_page_api.php/features'),
  getTestimonials: () => api.get('/landing_page_api.php/testimonials'),
  getFAQ: () => api.get('/landing_page_api.php/faq'),

  // Admin endpoints - Carousel
  createCarousel: (data) => api.post('/landing_page_api.php/admin/carousel', data),
  updateCarousel: (id, data) => api.put(`/landing_page_api.php/admin/carousel/${id}`, data),
  deleteCarousel: (id) => api.delete(`/landing_page_api.php/admin/carousel/${id}`),

  // Admin endpoints - Features
  createFeature: (data) => api.post('/landing_page_api.php/admin/features', data),
  updateFeature: (id, data) => api.put(`/landing_page_api.php/admin/features/${id}`, data),
  deleteFeature: (id) => api.delete(`/landing_page_api.php/admin/features/${id}`),

  // Admin endpoints - Testimonials
  createTestimonial: (data) => api.post('/landing_page_api.php/admin/testimonials', data),
  updateTestimonial: (id, data) => api.put(`/landing_page_api.php/admin/testimonials/${id}`, data),
  deleteTestimonial: (id) => api.delete(`/landing_page_api.php/admin/testimonials/${id}`),

  // Admin endpoints - FAQ
  createFAQ: (data) => api.post('/landing_page_api.php/admin/faq', data),
  updateFAQ: (id, data) => api.put(`/landing_page_api.php/admin/faq/${id}`, data),
  deleteFAQ: (id) => api.delete(`/landing_page_api.php/admin/faq/${id}`),

  // Admin endpoints - Content
  updateContent: (id, data) => api.put(`/landing_page_api.php/admin/content/${id}`, data),
};

export { api, landingPageAPI };
export default landingPageAPI;
